import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";

// import MultiSelect from '../../../../../common/components/multipleSelect/multipleSelect';

import BrandsTypes from "./Fields/BrandsTypes";
import ModelsTypes from "./Fields/ModelsTypes";
import ColorsTypes from "./Fields/ColorsTypes";
import TachographsTypes from "./Fields/TachographsTypes";
import CategoriesTypes from "./Fields/CategoriesTypes";

import AdvertisingsTypes from "./Fields/AdvertisingsTypes";
import TransfersTypes from "./Fields/TransfersTypes";
import TintsTypes from "./Fields/TintsTypes";
import AppliancesTypes from "./Fields/AppliancesTypes";
import ConditionersTypes from "./Fields/ConditionersTypes";
import InteriorsTypes from "./Fields/InteriorsTypes";
import SeatMaterialsTypes from "./Fields/SeatMaterialsTypes";
import FacilitiesTypes from "./Fields/FacilitiesTypes";
import EntertainmentsTypes from "./Fields/EntertainmentsTypes";
import VehicleDocument from "./Fields/VehicleDocument";

import ProductionYear from "./Fields/ProductionYear";
import PassengerCapacity from "./Fields/PassengerCapacity";
import UsagePrice from "./Fields/UsagePrice";
import MinimumOrderAmount from "./Fields/MinimumOrderAmount";
import LuggageCapacity from "./Fields/LuggageCapacity";

import DateCreated from "./Fields/DateCreated";
import OrdersForPeriod from "./Fields/OrdersForPeriod";
import ExpirationOfDocuments from "./Fields/ExpirationOfDocuments";

// без данных
// import FixedDriver from './Fields/FixedDriver';
import TypeOfServices from "./Fields/TypeOfServices";
import VehicleOwner from "./Fields/VehicleOwner";
import CompanyExecutor from "./Fields/CompanyExecutor";

import { Row, Col, Form, Input, Divider, Button, Icon } from "antd";

const Search = Input.Search;

class VehiclesFilters extends PureComponent {
  state = {
    moreFilters: false
  };

  showFilters = () => {
    let { moreFilters } = this.state;
    this.setState({
      moreFilters: !moreFilters
    });
  };

  render() {
    let { moreFilters } = this.state;
    const {
      // showDrawer,
      getModelsByBrandsKeys,
      form,
      countActiveFilter,
      onChangeSearch,
      searchValue,
      resetFilters
    } = this.props;
    return (
      <Fragment>
        <div className="b-table-filters">
          <Row>
            <Col span={18} className="filtersInfoPanel">
              {!countActiveFilter ? (
                <span className="savedCount">Выбрано фильтров: 0</span>
              ) : (
                <div className="filterBtns">
                  <div className="btnGroup">
                    <span className="filtersInfoBadge">
                      <Icon
                        style={{ fill: "#00a8ff" }}
                        type="info-circle"
                        theme="filled"
                      />
                      Выбрано фильтров:{" "}
                      {countActiveFilter !== null ? countActiveFilter : 0}
                    </span>
                    <span onClick={resetFilters} className="resetFilters">
                      Сбросить
                    </span>
                  </div>
                  {/* <Button
                    type="primary"
                    style={{marginLeft: '24px'}}
                    id="showTen"
                    onClick={() => {
                      filtersData !== null &&
                        applyFilters({
                          filtersArray: filtersData,
                          includeStatusKey,
                        });
                    }}
                  >
                    Показать {filteredCount} ТС
                  </Button> */}
                </div>
              )}
            </Col>
            <Col span={6}>
              <Search
                name="searchFilter"
                value={searchValue}
                className="search"
                allowClear={true}
                placeholder="Поиск по ТС"
                onChange={onChangeSearch}
              />
            </Col>
          </Row>
        </div>
        <div className="b-table-filters">
          <Row>
            <Col span={6}>
              <BrandsTypes
                form={form}
                onChange={arr => {
                  if (arr.length !== 0) {
                    getModelsByBrandsKeys(arr);
                  }
                }}
              />
            </Col>
            <Col span={6}>
              <ModelsTypes form={form} />
            </Col>
            {/*<Col span={6}>*/}
            {/*  <FixedDriver form={form} />*/}
            {/*</Col>*/}
            <Col span={6}>
              <OrdersForPeriod form={form} />
            </Col>
            <Col span={6}>
              <PassengerCapacity form={form} />
            </Col>
          </Row>
          <Row>
            <Col span={6}>
              <CategoriesTypes form={form} />
            </Col>
            <Col span={6}>
              <ProductionYear form={form} />
            </Col>
            <Col span={6}>
              <DateCreated form={form} />
            </Col>
            {/*{!moreFilters && (*/}
            {/*  <Fragment>*/}
            {/*    <Col*/}
            {/*      span={6}*/}
            {/*      align="right"*/}
            {/*      className="b-table-filters__no-label"*/}
            {/*    >*/}
            {/*      <Button*/}
            {/*        type="link"*/}
            {/*        className="withIcon withIcon_setting right"*/}
            {/*        onClick={showDrawer}*/}
            {/*      >*/}
            {/*        Настроить столбцы*/}
            {/*        <Icon type="setting" />*/}
            {/*      </Button>*/}
            {/*    </Col>*/}
            {/*    <Col*/}
            {/*      span={6}*/}
            {/*      align="right"*/}
            {/*      className="b-table-filters__no-label"*/}
            {/*    >*/}
            {/*      <Button*/}
            {/*        type="link"*/}
            {/*        className="withIcon small right"*/}
            {/*        onClick={this.showFilters}*/}
            {/*      >*/}
            {/*        Показать еще фильтры*/}
            {/*        <Icon type="down" />*/}
            {/*      </Button>*/}
            {/*    </Col>*/}
            {/*  </Fragment>*/}
            {/*)}*/}
            {moreFilters && (
              <Fragment>
                <Col span={6}>
                  <TachographsTypes form={form} />
                </Col>
                <Col span={6}>
                  <ColorsTypes form={form} />
                </Col>
              </Fragment>
            )}
          </Row>
          {moreFilters && (
            <Fragment>
              <Divider />
              <Row>
                <Col span={6}>
                  <TypeOfServices form={form} />
                </Col>
                <Col span={6}>
                  <VehicleOwner form={form} />
                </Col>
                <Col span={6}>
                  <CompanyExecutor form={form} />
                </Col>
                {/*<Col span={6}>*/}
                {/*  <DateCreated form={form} />*/}
                {/*</Col>*/}
              </Row>
              <Divider />
              <Row>
                <Col span={6}>
                  <UsagePrice form={form} />
                </Col>
                <Col span={6}>
                  <MinimumOrderAmount form={form} />
                </Col>
                <Col span={6} />
                {/*<Col span={6}>*/}
                {/*  <OrdersForPeriod form={form} />*/}
                {/*</Col>*/}
              </Row>
              <Divider />
              <Row>
                <Col span={6}>
                  <ExpirationOfDocuments form={form} />
                </Col>
                <Col span={6}>
                  <VehicleDocument form={form} />
                </Col>
                <Col span={6} />
                <Col span={6} />
              </Row>
              <Divider />
              <Row>
                <Col span={6}>
                  <EntertainmentsTypes form={form} />
                </Col>
                <Col span={6}>
                  <FacilitiesTypes form={form} />
                </Col>
                <Col span={6}>
                  <SeatMaterialsTypes form={form} />
                </Col>
                <Col span={6}>
                  <InteriorsTypes form={form} />
                </Col>
              </Row>
              <Row>
                <Col span={6}>
                  <ConditionersTypes form={form} />
                </Col>
                <Col span={6}>
                  <AppliancesTypes form={form} />
                </Col>
                <Col span={6}>
                  <TintsTypes form={form} />
                </Col>
                <Col span={6}>
                  <TransfersTypes form={form} />
                </Col>
              </Row>
              <Row>
                <Col span={6}>
                  <LuggageCapacity form={form} />
                </Col>
                <Col span={6} />
                <Col span={6}>
                  <AdvertisingsTypes form={form} />
                </Col>
                <Col span={6} />
              </Row>
              <Divider />
              <Row>
                {countActiveFilter !== null && countActiveFilter > 0 ? (
                  <Fragment>
                    <Col span={12} className="filtersInfoPanel">
                      <div className="btnGroup">
                        <span className="filtersInfoBadge">
                          <Icon
                            style={{ fill: "#00a8ff" }}
                            type="info-circle"
                            theme="filled"
                          />
                          Выбрано фильтров:{" "}
                          {countActiveFilter !== null ? countActiveFilter : 0}
                        </span>
                        <span onClick={resetFilters} className="resetFilters">
                          Сбросить
                        </span>
                      </div>
                      {/*<Button
                        type="primary"
                        id="showTen"
                        onClick={() => {
                          filtersData !== null &&
                            applyFilters({
                              filtersArray: filtersData,
                              includeStatusKey,
                            });
                        }}
                      >
                        Показать {filteredCount} ТС
                      </Button>*/}
                    </Col>
                  </Fragment>
                ) : (
                  <Fragment>
                    <Col span={12}>
                      <div className="filtersInfoPanel">
                        <span className="savedCount">Выбрано фильтров: 0</span>
                      </div>
                    </Col>
                  </Fragment>
                )}

                <Col span={6} align="right">
                  {/* <Button
                    type="link"
                    className="withIcon withIcon_setting right"
                    onClick={showDrawer}
                  >
                    Настроить столбцы
                    <Icon type="setting" />
                  </Button> */}
                </Col>
                <Col span={6} align="right">
                  <Button
                    type="link"
                    className="withIcon small right"
                    onClick={this.showFilters}
                  >
                    Скрыть фильтры
                    <Icon type="up" />
                  </Button>
                </Col>
              </Row>
            </Fragment>
          )}
        </div>
      </Fragment>
    );
  }
}

const FormTransportFilter = Form.create({
  name: "vehiclesFilters",
  onFieldsChange(props) {
    props.handleFiltersChange(props.form.getFieldsValue());
  },
  mapPropsToFields(props) {
    let obj = {};
    props.data &&
      Object.keys(props.data).forEach(name => {
        obj[name] = Form.createFormField({
          value: props.data[name]
        });
      });
    return obj;
  },
  onValuesChange(props, values) {}
})(VehiclesFilters);

export default connect(state => ({
  countActiveFilter: state.Transport.Vehicles.filters.count,
  searchValue: state.Transport.Vehicles.filters.search,
  data: state.Transport.Vehicles.filters.fields
}))(FormTransportFilter);
/*
export default Form.create({
  onValuesChange: (props, changedValues, allValues) => {
    const {
      filterVehicles,
      setFiltersCount,
      marks,
      resetFiltersVehicles,
    } = props;
    const { includeStatusKey } = marks;
    let filtersArray = [];
    for (let [key, value] of Object.entries(allValues)) {
      if (value instanceof Array && value.length) {
        filtersArray.push({ [key]: value });
      }
      if (typeof value === 'number' && value > 0) {
        filtersArray.push({ [key]: value });
      }
      if (value instanceof moment) {
        filtersArray.push({ [key]: value });
      }
    }
    if (filtersArray.length > 0) {
      setFiltersCount(filtersArray);
      filterVehicles({ filtersArray, includeStatusKey });
    } else {
      resetFiltersVehicles();
    }
  },
})(VehiclesFilters);
*/
